<script setup>
import { confirmState, resolveConfirm } from "@/composables/useConfirm";
</script>

<template>
  <Teleport to="body">
    <div v-if="confirmState.visible" class="agv-confirm-overlay" @click.self="resolveConfirm(false)" @keydown.esc="resolveConfirm(false)">
      <div class="agv-confirm-box" role="alertdialog" aria-modal="true">
        <div class="agv-confirm-icon" :class="confirmState.type">
          <i :class="confirmState.type === 'danger' ? 'fa-solid fa-trash-can' : 'fa-solid fa-triangle-exclamation'"></i>
        </div>
        <h5 class="agv-confirm-title">{{ confirmState.title }}</h5>
        <p class="agv-confirm-message">{{ confirmState.message }}</p>
        <div class="agv-confirm-actions">
          <button type="button" class="agv-btn agv-btn-cancel" @click="resolveConfirm(false)">{{ confirmState.cancelText }}</button>
          <button type="button" class="agv-btn agv-btn-confirm" :class="confirmState.type" @click="resolveConfirm(true)">{{ confirmState.confirmText }}</button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<style scoped>
.agv-confirm-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 20000;
  padding: 16px;
}
.agv-confirm-box {
  background: #fff;
  border-radius: 14px;
  padding: 28px 26px 22px;
  width: 100%;
  max-width: 420px;
  text-align: center;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.25);
}
.agv-confirm-icon {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  margin: 0 auto 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  background: #fff4e0;
  color: #f0a020;
}
.agv-confirm-icon.danger {
  background: #fdeaea;
  color: #dc3545;
}
.agv-confirm-title {
  font-weight: 700;
  color: #1b1b1b;
  margin-bottom: 8px;
}
.agv-confirm-message {
  color: #555;
  font-size: 15px;
  margin-bottom: 22px;
}
.agv-confirm-actions {
  display: flex;
  gap: 10px;
  justify-content: center;
}
.agv-btn {
  border: 1px solid transparent;
  border-radius: 8px;
  padding: 9px 22px;
  font-weight: 600;
  cursor: pointer;
}
.agv-btn-cancel {
  background: #fff;
  border-color: #ccc;
  color: #444;
}
.agv-btn-confirm {
  background: #482775;
  color: #fff;
}
.agv-btn-confirm.danger {
  background: #dc3545;
}
</style>
